import React from 'react';

function TagBadge({ name, color = '#6b7280', onRemove, size = 'small' }) {
  const bg = color + '20';
  const isSmall = size === 'small';

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      fontSize: isSmall ? 11 : 12,
      padding: isSmall ? '1px 6px' : '2px 8px',
      borderRadius: 12,
      background: bg,
      color: color,
      border: `1px solid ${color}40`,
      fontWeight: 500,
      whiteSpace: 'nowrap',
      lineHeight: isSmall ? '16px' : '18px',
    }}>
      {name}
      {onRemove && (
        <span
          onClick={(e) => { e.stopPropagation(); onRemove(); }}
          style={{ cursor: 'pointer', marginLeft: 2, fontWeight: 700, fontSize: isSmall ? 12 : 14 }}
          title="Remove tag"
        >&times;</span>
      )}
    </span>
  );
}

export default TagBadge;
